import React from 'react';

const Globe = () => {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
             viewBox="0 0 34 34" width="34" height="34">
            <path fill="#212121" d="M17,0.3C17,0.3,17,0.3,17,0.3C17,0.3,17,0.3,17,0.3L17,0.3c-0.2,0-0.4,0-0.6,0v0c-0.3,0-0.5,0-0.8,0.1
                C7.1,1.1,0.3,8.3,0.3,17c0,8.7,6.8,15.9,15.3,16.6c0.3,0,0.5,0.1,0.8,0.1v0c0.2,0,0.4,0,0.6,0v0c0,0,0,0,0,0c0,0,0,0,0,0
                c9.2,0,16.7-7.5,16.7-16.7C33.7,7.8,26.2,0.3,17,0.3z M31.8,16.1h-5.4c-0.1-2.8-0.6-5.5-1.3-7.8C26,8,27,7.5,27.9,7
                C30.1,9.5,31.5,12.6,31.8,16.1z M15.9,31.7C14,31.5,12.2,29.7,11,27c1.7-0.5,3.4-0.7,5.1-0.8v5.5C16,31.8,15.9,31.8,15.9,31.7z
                 M10.9,30.4c-1.2-0.6-2.3-1.3-3.4-2.1c0.5-0.3,1.1-0.5,1.7-0.7C9.6,28.7,10.2,29.6,10.9,30.4z M15.9,2.3c0.1,0,0.1,0,0.2,0v5.5
                c-1.7,0-3.4-0.3-5.1-0.8C12.2,4.3,14,2.5,15.9,2.3z M9.2,6.4C8.6,6.2,8,5.9,7.5,5.7c1-0.9,2.1-1.6,3.4-2.1C10.2,4.4,9.6,5.3,9.2,6.4
                z M22.3,3.2c1.5,0.6,3,1.4,4.2,2.5c-0.7,0.3-1.4,0.6-2.2,0.9C23.8,5.3,23.1,4.1,22.3,3.2z M22.5,7.1c-1.5,0.4-3,0.6-4.6,0.6V2.3
                C19.7,2.8,21.3,4.6,22.5,7.1z M16.1,9.6v6.4H9c0.1-2.7,0.6-5.2,1.3-7.3C12.1,9.3,14.1,9.6,16.1,9.6z M16.1,17.9v6.4
                c-2,0-3.9,0.4-5.8,0.9C9.5,23.1,9,20.6,9,17.9H16.1z M17.9,31.7v-5.4c1.6,0,3.1,0.2,4.6,0.6C21.3,29.4,19.7,31.2,17.9,31.7z
                 M24.4,27.4c0.7,0.3,1.5,0.6,2.2,0.9c-1.2,1-2.7,1.9-4.2,2.5C23.1,29.9,23.8,28.7,24.4,27.4z M17.9,24.4v-6.4h6.5
                c-0.1,2.6-0.5,5.1-1.3,7.2C21.5,24.7,19.7,24.4,17.9,24.4z M17.9,16.1V9.6c1.8,0,3.6-0.3,5.3-0.7c0.7,2.1,1.2,4.6,1.2,7.2H17.9z
                 M6.1,7c0.8,0.4,1.6,0.8,2.4,1.1c-0.8,2.3-1.3,5-1.4,7.9H2.2C2.5,12.6,3.9,9.5,6.1,7z M2.2,17.9h4.8c0.1,2.9,0.6,5.6,1.4,7.9
                c-0.8,0.3-1.6,0.7-2.4,1.1C3.9,24.5,2.5,21.4,2.2,17.9z M27.9,27C27,26.5,26,26,25,25.7c0.8-2.3,1.2-4.9,1.3-7.8h5.4
                C31.5,21.4,30.1,24.5,27.9,27z"/>
        </svg>
    )
}

export default Globe;
